import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PortalTaskFormType, PortalTaskModel } from './portal-task.model';
import { PortalTasksService } from './portal-tasks.service';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'portal-tasks',
  templateUrl: './portal-tasks.component.html',
  styleUrls: ['./portal-tasks.component.scss'],
  standalone: false
})
export class PortalTasksComponent implements OnInit {
  tasks: PortalTaskModel[] = [];
  @Output() loadedComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private portalTasksService: PortalTasksService,
    private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) {}

  async ngOnInit(): Promise<void> {
    this.tasks = await this.portalTasksService.getTasks();
    this.loadedComplete.emit(true);
  }

  startSubmission(task: PortalTaskModel): void {
    switch (task.formType) {
      case PortalTaskFormType.Form:
      case PortalTaskFormType.TeamForm:
        this.oidcSecurityService.getUserData().subscribe((userData) => {
          const userId = userData?.sub;
          if (!userId) {
            return;
          }
          this.router.navigateByUrl(`portal/forms/${userId}/application/${task.secureLinkId}`);
        });
        break;
      default:
        this.router.navigateByUrl(
          `portal/forms/${task.formType.toLowerCase()}/${task.secureLinkId}`
        );
    }
  }
}
